<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('trickshots')"
      :columns="columns"
      :column_search="true"
      resource_url="/trickshot/datatables"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon">
            <i class="fa fa-plus"></i>
          </span>
          <span>{{ $t("add") }}</span>
        </button>
      </template>
    </generic-table>
  </div>

  <trickshot-modal ref="trickshot_modal" @success="refresh" />
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  post,
  error_message,
  format_date,
  format_currency,
} from "@/utils";
import TrickshotModal from "./trickshot_modal/Index.vue";

export default {
  name: "TrickshotsDatatable",
  components: { GenericTable, TrickshotModal },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("date"),
          name: "date",
          searchable: false,
          width: "15%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return v.format_date(row.date) || "";
          },
        },
        {
          title: v.$t("player"),
          name: "player",
          width: "40%",
          data: (row) => {
            return row.player;
          },
        },
        {
          title: v.$t("place"),
          name: "place",
          width: "40%",
          data: (row) => {
            return row.place;
          },
        },
        {
          title: v.$t("options"),
          width: "30%",
          searchable: false,
          data: (row) => {
            let btns = [
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: function (e) {
                  v.$refs.trickshot_modal.show_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete trickshot?"),
                    v,
                    () => {
                      del("/trickshot", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ];

            return generate_datatables_buttons(btns);
          },
        },
      ],
    };
  },
  methods: {
    format_date,
    format_currency,
    create() {
      let v = this;
      v.$refs.trickshot_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
